import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function BrandSelector({
  selectedBrand,
  setSelectedBrand,
  availableBrands = [],
  mobile,
}) {
  if (availableBrands.length === 0) {
    return null;
  }

  const getBrandColor = (brandName) => {
    const karsten = themeColorsDesingSystem.brands.karsten;
    const trussardi = themeColorsDesingSystem.brands.trussardi;

    switch (brandName) {
      case "trussardi":
        return trussardi.primary;
      case "mix":
        return "#555";
      case "karsten":
      default:
        return karsten.primary;
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: mobile ? "4px" : "16px",
        right: mobile ? "4px" : "16px",
        zIndex: 50,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(8px)",
        padding: "4px",
        borderRadius: "9999px",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      {availableBrands.map((brand) => (
        <button
          key={brand.id}
          onClick={() => {
            if (!brand.disabled) {
              setSelectedBrand(brand.name);
            }
          }}
          disabled={brand.disabled}
          style={{
            padding: "4px 12px",
            fontSize: "14px",
            fontWeight: "bold",
            borderRadius: "9999px",
            backgroundColor:
              selectedBrand === brand.name && !brand.disabled
                ? getBrandColor(brand.name)
                : "transparent",
            color:
              selectedBrand === brand.name && !brand.disabled
                ? "white"
                : brand.disabled
                ? "#ccc"
                : "#424242",
            border: "none",
            cursor: brand.disabled ? "not-allowed" : "pointer",
            opacity: brand.disabled ? 0.5 : 1,
          }}
        >
          {brand.label}
        </button>
      ))}
    </div>
  );
}
